import React from "react";
import fileHandlerBeforeUpload from "../../utils/fileHandlerBeforeUpload";
import { ListItem } from "../List";
import icons from "../../constants/icons";
import FilePreviewName from "./FilePreviewName";
import {
  fetchBusinessRequiredFiles,
  fetchUserFiles,
  viewUploadedFile,
} from "../../queries/files/fileQuery";
import { Loading } from "../Loader";
import { connect } from "react-redux";
import toastMessage from "../../utils/toastMessage";
import axios from "axios";
import language from "../../language";
import { getStorage } from "../../utils/storage";
import { DeleteModal, Modal } from "../Modal";
import api from "../../utils/api";

class FileUpload extends React.Component {
  state = {
    listOfFilesToUpload: [],
    error: {},
    isLoading: true,
    isSubmitting: false,
    userFiles: [],
    selectedData: {},
    deleteValue: "",
  };

  componentDidMount = async () => {
    await this.getAuthenticatedUserFiles();
    await this.getRequiredFiles();
  };

  getRequiredFiles = async () => {
    const { defaultLanguage, profileUnitId } = this.props;

    try {
      this.setState({ isLoading: true });

      let listOfFilesToUpload = await fetchBusinessRequiredFiles(
        defaultLanguage,
        {
          listType: "dropdown",
          profileUnitId,
        }
      );

      this.setState({
        listOfFilesToUpload,
        isLoading: false,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  getAuthenticatedUserFiles = async (isLoading) => {
    const { defaultLanguage } = this.props;

    try {
      this.setState({ isLoading });

      const files = await fetchUserFiles(defaultLanguage);

      if (!files) return;

      const userFiles = await Promise.all(
        files.map(async (file) => {
          const url = await viewUploadedFile(defaultLanguage, {
            fileId: file.id,
          });
          return {
            ...file,
            tmpURL: url,
          };
        })
      );

      this.setState({
        isLoading: false,
        userFiles,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handleFiles(file, index) {
    let modifiedFile = fileHandlerBeforeUpload(file);

    let { listOfFilesToUpload, error } = this.state;

    delete error[listOfFilesToUpload[index].type];

    listOfFilesToUpload[index]["uploadedFile"] = modifiedFile;

    this.setState({ listOfFilesToUpload, error }, () => {
      this.onSubmit(index);
    });
  }

  handleRemoveFile({ fileIndex, userFile }) {
    let { listOfFilesToUpload } = this.state;

    delete listOfFilesToUpload[fileIndex].uploadedFile;

    if (userFile) {
      this.handleShowModal("showDeleteModal", userFile.fileType, userFile);
    }

    this.setState({ listOfFilesToUpload });
  }

  validateFiles(index) {
    let { error, listOfFilesToUpload, userFiles = [] } = this.state;

    const file = listOfFilesToUpload[index];
    if (!file) return;

    if (
      !file.uploadedFile &&
      !userFiles.find((userFile) => userFile.fileTypeId === file.id)
    ) {
      error[file.type] =
        file.type + " " + language[this.props.defaultLanguage].is_mandatory;
    }

    this.setState({ error });
  }

  onSubmit = async (fileIndex) => {
    await this.validateFiles(fileIndex);

    let { error, listOfFilesToUpload } = this.state;
    const { profileUnitId } = this.props;

    if (Object.keys(error).length === 0) {
      const user = await getStorage();

      this.setState({
        [`isSubmitting_${fileIndex}`]: true,
      });

      const file = listOfFilesToUpload[fileIndex];

      if (!file) return;

      //   if (userFiles.find((userFile) => userFile.fileTypeId === el.id))
      //         return;

      let formData = new FormData();

      formData.append("fileTypeId", file.id);
      formData.append("profileUnitId", profileUnitId);
      formData.append("fileToUpload", file.uploadedFile);

      const options = {
        method: "POST",
        url: `${api("file")}/upload`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + user.accessToken,
        },
      };

      axios(options)
        .then((data) => {
          toastMessage(
            "success",
            language[this.props.defaultLanguage].upload_file_success
          );

          this.setState({
            [`isSubmitting_${fileIndex}`]: false,
          });

          //   this.handlePreviewFile(fileIndex, data.data.id);

          this.getAuthenticatedUserFiles(false);

          this.props.profileUpdated && this.props.profileUpdated();
        })
        .catch((error) => {
          this.setState({
            [`isSubmitting_${fileIndex}`]: false,
          });

          toastMessage(
            "error",
            language[this.props.defaultLanguage].upload_file_error +
              " " +
              file.type
          );
        });
    }
  };

  handlePreviewFile = async (fileIndex, fileId) => {
    const { defaultLanguage } = this.props;
    let { userFiles = [] } = this.state;

    try {
      const fileUrl = await viewUploadedFile(defaultLanguage, { fileId });
    } catch (error) {
      console.log(error);
      toastMessage(
        "error",
        "Unable to preview this file, refresh the page or upload the file"
      );
    }
  };

  handleShowModal(modal, title, selectedData) {
    this.setState({
      selectedData,
      [modal]: true,
      modalTitle: title,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target.value,
    });
  }

  handleDeleteFileFromRemote = async (file) => {
    const user = await getStorage();
    let options = {
      method: "DELETE",
      url: `${api("file")}`,
      data: {
        fileId: file.id,
      },
      headers: {
        Authorization: `Bearer ${user.accessToken}`,
      },
    };

    axios(options)
      .then((data) => {
        this.setState({ isDeleting: false });

        toastMessage("success", "File deleted successfully");
      })
      .catch((err) => {
        this.setState({ isDeleting: false });

        toastMessage("error", "Unable to delete file");
      });
  };

  render() {
    const { listOfFilesToUpload = [] } = this.state;
    return (
      <>
        {listOfFilesToUpload.length > 0 && (
          <>
            <hr />
            <div>
              {this.state.isLoading ? (
                <Loading />
              ) : (
                <>
                  {listOfFilesToUpload.length > 0 && (
                    <div className="card-header">
                      <h3 className="text-bold mb-1">Documents Required</h3>
                      <p className="text-disabled">
                        Please upload the below document(s). All is mandatory
                      </p>
                    </div>
                  )}
                  <div className="card-body">
                    {listOfFilesToUpload.map((el, i) => {
                      const userFile =
                        this.state.userFiles.find(
                          (flEl) => flEl.fileTypeId === el.id
                        ) || {};

                      return (
                        <div key={i}>
                          <div className="mb-3">
                            <ListItem
                              icon="upload_file"
                              title={el.type}
                              status={el.uploaded}
                              key={i}
                              required
                              className="bordered"
                              rightIcon={el.uploaded && icons.success}
                              rightButtons={[
                                {
                                  name: "Upload",
                                  type: "upload",
                                  onPress: (file) => this.handleFiles(file, i),
                                },
                              ]}
                            />
                            {(el.uploadedFile ||
                              Object.keys(userFile || {}).length > 0) && (
                              <div className="mt-1">
                                <FilePreviewName
                                  name={
                                    userFile
                                      ? userFile.fileName
                                      : el?.uploadedFile?.name ||
                                        userFile.tmpURL
                                  }
                                  tmpURL={userFile.tmpURL}
                                  type={el?.uploadedFile?.type}
                                  uploadedFile={this.state.userFiles}
                                  handleRemoveFile={() =>
                                    this.handleRemoveFile({
                                      fileIndex: i,
                                      userFile,
                                    })
                                  }
                                  isLoading={this.state[`isSubmitting_${i}`]}
                                />
                                {/* <hr /> */}
                              </div>
                            )}
                            {this.state.error[el.type] && (
                              <div
                                style={{ minHeight: 40, marginLeft: "1rem" }}
                              >
                                <span className="text-error">
                                  {this.state.error[el.type]}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </>
        )}
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <DeleteModal
            name={this.state.selectedData.fileName}
            value={this.state.deleteValue}
            error={this.state.deleteError}
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            onDelete={() =>
              this.handleDeleteFileFromRemote(this.state.selectedData)
            }
            isDeleting={this.state.isDeleting}
            onChange={(e) => this.onChangeText("deleteValue", e)}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { businessProfileSavedSuccess } = state.BusinessProfile;
  const { profileUnits } = state.ProfileUnits;
  return {
    defaultLanguage,
    businessProfileSavedSuccess,
    profileUnits,
  };
};

export default connect(mapStateToProps)(FileUpload);
